/* Mintier: highlight the 90-day supply plan in the Recharge quantity-upsell widget.
   - 90-day card gets a deep-green header bar ("Recommended · Best value", texts from Recharge settings),
     mint body, green border, green radio and green benefit checks. Its floating pills are dropped.
   - Other plans: plain cards, no Recommended/Best value pills.
   - Products without a 90-day plan keep Recharge's default badges (minus "Best value"). */
(function () {
  var TAG = 'recharge-quantity-upsell';
  var GREEN = '#1F5C43';
  var CSS =
    '.rc-quantity-upsell-option[data-mt-featured]{' +
      'border:1.5px solid ' + GREEN + ' !important;background:#EEF7F3 !important;color:#151515 !important;' +
      'overflow:hidden;--rc-widget-brand-color:' + GREEN + ';--rc-widget-brand-color-50:' + GREEN + ';}' +
    '.rc-quantity-upsell-option[data-mt-featured]::before{content:attr(data-mt-featured);display:block;' +
      'background:' + GREEN + ';color:#FFFFFF;font-family:Figtree,inherit;font-weight:700;font-size:12px;' +
      'line-height:16px;letter-spacing:.12em;text-transform:uppercase;text-align:center;padding:9px 12px;}' +
    '.rc-quantity-upsell-option[data-mt-featured] .rc-quantity-upsell-option__content-container::after{content:"*Prepaid for 3 months";display:block;' +
      'margin-top:10px;font-family:Figtree,inherit;font-size:12px;line-height:16px;font-weight:400;color:rgba(21,21,21,.7);}' +
    '.rc-quantity-upsell-option[data-mt-featured] rc-benefits{--rc-widget-bullet-icon-image-color:' + GREEN + ';}' +
    '.rc-quantity-upsell-option[data-mt-featured] .rc-purchase-option__recommended-badge,' +
    '.rc-quantity-upsell-option[data-mt-featured] .rc-purchase-option__best-value-badge{display:none !important;}';

  function planName(el, i) {
    var p = el.variantPlans && el.variantPlans[i];
    if (!p) return '';
    var sp = (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.shopifyPlans) || [];
    for (var k = 0; k < sp.length; k++) if (String(sp[k].id) === String(p.external_plan_id)) return sp[k].name || '';
    return p.title || p.name || '';
  }
  var VALUE_ADDS = ['Free shipping in Canada &amp; US', 'Skip, pause or cancel anytime'];
  function nameOf(p) {
    var sp = (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.shopifyPlans) || [];
    for (var k = 0; k < sp.length; k++) if (String(sp[k].id) === String(p.external_plan_id)) return sp[k].name || '';
    return p.title || p.name || '';
  }
  function is90(el, i) { return /90/.test(planName(el, i)); }
  function has90(el) {
    var n = (el.variantPlans || []).length;
    for (var i = 0; i < n; i++) if (is90(el, i)) return true;
    return false;
  }
  function qs(el) { return (el.settings && el.settings.quantity_upsell) || {}; }
  function headerText(el) {
    var q = qs(el), parts = [];
    if (q.badgeRecommended !== false && q.badgeRecommendedText) parts.push(q.badgeRecommendedText);
    if (q.badgeBestValue !== false && q.badgeBestValueText) parts.push(q.badgeBestValueText);
    return parts.join(' \u00B7 ');
  }

  function decorate(el) {
    var root = el.shadowRoot;
    if (!root) return;
    if (!root.__mtStyled) {
      root.__mtStyled = true;
      try {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
      } catch (e) {
        var st = document.createElement('style');
        st.textContent = CSS;
        root.appendChild(st);
      }
    }
    var n = (el.variantPlans || []).length, text = headerText(el);
    root.querySelectorAll('.rc-quantity-upsell-option').forEach(function (opt, i) {
      if (i < n && is90(el, i) && text) opt.setAttribute('data-mt-featured', text);
      else opt.removeAttribute('data-mt-featured');
    });
  }

  function patch(C) {
    var proto = C && C.prototype;
    if (!proto || proto.__mintierBadges) return;
    proto.__mintierBadges = true;
    var origRec = proto.recommendedText, origUpdated = proto.updated;
    proto.recommendedText = function (i) {
      if (!has90(this)) return origRec.call(this, i);
      return undefined; /* shown in the 90-day header bar instead */
    };
    proto.bestValueText = function () { return undefined; };
    var origBen = proto.benefitsTemplate;
    if (origBen) proto.benefitsTemplate = function (plan) {
      var r = origBen.apply(this, arguments);
      try {
        if (plan && r && r.values && /90/.test(nameOf(plan))) {
          for (var k = 0; k < r.values.length; k++) {
            if (typeof r.values[k] === 'string' && /<li>/.test(r.values[k])) {
              var first = (r.values[k].match(/<li>[\s\S]*?<\/li>/) || [''])[0];
              r.values[k] = '<ul>' + first + VALUE_ADDS.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>';
            }
          }
        }
      } catch (e) {}
      return r;
    };
    proto.updated = function (c) {
      if (origUpdated) origUpdated.call(this, c);
      decorate(this);
    };
    findAll(document).forEach(function (el) { if (el.requestUpdate) el.requestUpdate(); });
  }

  function findAll(root, out) {
    out = out || [];
    root.querySelectorAll('*').forEach(function (n) {
      if (n.localName === TAG) out.push(n);
      if (n.shadowRoot) findAll(n.shadowRoot, out);
    });
    return out;
  }

  if (window.customElements) customElements.whenDefined(TAG).then(function () { patch(customElements.get(TAG)); });
})();

/* Mintier: homepage featured product (Wonder theme <sub-widget>).
   90-day supply = 3 units every 3 months: shows the 3-unit total, sets quantity 3 on the add-to-cart form,
   green "Recommended · Best value" card, Save pill and benefit lines like the product pages.
   Monthly / One-time = quantity 1. Only applies inside featured-product sections. */
(function () {
  var GREEN = '#1F5C43', UNITS = 3;
  var CHECK = '<svg class="mt-sw-check" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="12" cy="12" r="7.6" fill="none" stroke="currentColor" stroke-width="1.1"/><path d="M8.6 12.1l2.3 2.3 4.5-4.5" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  var CSS =
    '.wt-subscription-widget__plans[data-mt-featured]{position:relative;overflow:hidden;padding-top:calc(var(--mt-pt,16px) + 34px) !important;' +
      'border:1.5px solid ' + GREEN + ' !important;background:#EEF7F3 !important;' +
      '--block-color-accent:' + GREEN + ';--block-color-active-border:' + GREEN + ';--block-color-active-background:#EEF7F3;--block-color-border:' + GREEN + ';}' +
    '.mt-sw-header{position:absolute;top:0;left:0;right:0;background:' + GREEN + ';color:#fff;font-family:Figtree,inherit;font-weight:700;' +
      'font-size:12px;line-height:16px;letter-spacing:.12em;text-transform:uppercase;text-align:center;padding:9px 12px;}' +
    '.mt-sw-save{display:inline-block;margin-top:4px;background:#8A95A0;color:#fff;border-radius:16px;padding:0 8px;font-size:12px;font-weight:600;line-height:20px;}' +
    'sub-widget.mt-sw .wt-subscription-widget__plans:not(.wt-subscription-widget__plans--selected) .wt-subscription-widget__plan-content{margin-top:0;}' +
    'sub-widget.mt-sw .wt-subscription-widget__plan-content{flex-direction:column;}' +
    '.mt-sw-benefits{display:none;list-style:none;margin:0;padding:0;width:100%;font-size:14px;line-height:20px;font-weight:400;}' +
    '.wt-subscription-widget__plans--selected .mt-sw-benefits{display:block;}' +
    '.mt-sw-benefits li{display:flex;align-items:center;gap:8px;margin:0 0 8px;}' +
    '.mt-sw-check{flex:0 0 16px;color:#151515;}' +
    '.mt-sw-note{display:block;margin:12px 0 0;font-family:Figtree,inherit;font-size:12px;line-height:16px;font-weight:400;color:rgba(21,21,21,.7);}' +
    '[data-mt-featured] .mt-sw-check{color:' + GREEN + ';}';

  function isFeaturedSection(w) {
    var s = w.closest('[data-section-id]');
    return !!(s && /featured_product/.test(s.dataset.sectionId || ''));
  }
  function money(cents, sample) {
    sample = sample || '$0.00';
    var m = sample.match(/\d[\d.,\s]*\d|\d/);
    var comma = m && /,\d{2}$/.test(m[0]);
    var v = (cents / 100).toFixed(2);
    if (comma) v = v.replace('.', ',');
    return m ? sample.slice(0, m.index) + v + sample.slice(m.index + m[0].length) : v;
  }
  function planInfo(plan) {
    var sel = plan.querySelector('select');
    var opt = sel && sel.options[sel.selectedIndex >= 0 ? sel.selectedIndex : 0];
    if (!opt) return null;
    var title = (plan.querySelector('.wt-subscription-widget__plan-header__title-text') || {}).textContent || '';
    var p = Number(opt.dataset.priceRaw), c = Number(opt.dataset.compareAtPriceRaw);
    return { opt: opt, title: title.trim(), is90: /90/.test(title), p: p, c: c > p ? c : p, fmt: opt.dataset.priceFormatted || opt.dataset.price };
  }
  function qtyInput(w) {
    var q = w.querySelector(':scope > input[data-mt-qty]');
    if (q) return q;
    var sp = w.querySelector('input[name="selling_plan"]'), sel = w.querySelector('select[form]');
    var formId = (sp && sp.getAttribute('form')) || (sel && sel.getAttribute('form'));
    if (!formId) return null;
    q = document.createElement('input');
    q.type = 'hidden'; q.name = 'quantity'; q.value = '1';
    q.setAttribute('form', formId); q.setAttribute('data-mt-qty', '');
    w.appendChild(q);
    return q;
  }
  function decorate(w) {
    w.querySelectorAll('.wt-subscription-widget__plans').forEach(function (plan) {
      var info = plan.querySelector('select') && planInfo(plan);
      if (!info || plan.__mtDone === info.opt) return;
      plan.__mtDone = info.opt;
      plan.querySelectorAll('.mt-sw-header,.mt-sw-save,.mt-sw-benefits,.mt-sw-note').forEach(function (n) { n.remove(); });
      var units = info.is90 ? UNITS : 1, every = info.is90 ? '3 months' : 'month';
      var titleEl = plan.querySelector('.wt-subscription-widget__plan-header__title-text');
      if (info.c > info.p && titleEl) {
        var pill = document.createElement('span');
        pill.className = 'mt-sw-save';
        pill.textContent = 'Save ' + Math.round((info.c - info.p) / info.c * 100) + '%';
        titleEl.insertAdjacentElement('afterend', pill);
        titleEl.parentElement.style.flexWrap = 'wrap';
      }
      var ul = document.createElement('ul');
      ul.className = 'mt-sw-benefits';
      var lines = [units + (units === 1 ? ' unit' : ' units') + ' shipped every ' + every];
      if (info.is90) lines.push('Free shipping in Canada &amp; US', 'Skip, pause or cancel anytime');
      else {
        if (info.c > info.p) lines.push(money((info.c - info.p) * units, info.fmt) + ' saved every ' + every);
        lines.push(money(info.p, info.fmt) + ' per unit');
      }
      ul.innerHTML = lines.map(function (t) { return '<li>' + CHECK + '<span>' + t + '</span></li>'; }).join('');
      (plan.querySelector('.wt-subscription-widget__plan-content') || plan).appendChild(ul);
      if (info.is90) {
        if (!plan.style.getPropertyValue('--mt-pt')) plan.style.setProperty('--mt-pt', getComputedStyle(plan).paddingTop);
        plan.setAttribute('data-mt-featured', '');
        var h = document.createElement('div');
        h.className = 'mt-sw-header';
        h.textContent = 'Recommended \u00B7 Best value';
        plan.insertBefore(h, plan.firstChild);
        var note = document.createElement('div');
        note.className = 'mt-sw-note';
        note.textContent = '*Prepaid for 3 months';
        (plan.querySelector('.wt-subscription-widget__plan-content') || plan).appendChild(note);
      }
    });
  }
  function apply(w) {
    decorate(w);
    var q = qtyInput(w);
    var selPlan = w.querySelector('.wt-subscription-widget__plans--selected');
    var info = selPlan && selPlan.querySelector('select') ? planInfo(selPlan) : null;
    var units = info && info.is90 ? UNITS : 1;
    if (q) q.value = String(units);
    w.querySelectorAll('.wt-subscription-widget__plans').forEach(function (plan) {
      var pi = plan.querySelector('select') && planInfo(plan);
      if (!pi || !pi.is90) return;
      var pr = plan.querySelector('.wt-subscription-widget__plan-header__price-regular');
      var cp = plan.querySelector('.wt-subscription-widget__plan-header__price-sale');
      if (pr) pr.textContent = money(pi.p * UNITS, pi.fmt);
      if (cp) cp.textContent = money(pi.c * UNITS, pi.fmt);
    });
    if (info && info.is90 && typeof w.updatePriceBlock === 'function') {
      var d = { price: money(info.p * UNITS, info.fmt), compareAtPrice: money(info.c * UNITS, info.fmt), priceRaw: info.p * UNITS, compareAtPriceRaw: info.c * UNITS };
      try { w.updatePriceBlock(d); w.updateStickyPriceBlock(d); } catch (e) {}
    }
  }
  function hook(w) {
    if (w.__mtHooked || !isFeaturedSection(w) || typeof w.handlePlanClick !== 'function') return;
    w.__mtHooked = true;
    w.classList.add('mt-sw');
    var orig = w.handlePlanClick;
    w.handlePlanClick = function (plan) {
      try { decorate(w); } catch (e) {}
      var r = orig.apply(this, arguments);
      try { apply(w); } catch (e) {}
      return r;
    };
    var sel = w.querySelector('.wt-subscription-widget__plans--selected');
    if (sel) w.handlePlanClick(sel); else apply(w);
  }
  function run() {
    if (!document.getElementById('mt-sw-css')) {
      var st = document.createElement('style'); st.id = 'mt-sw-css'; st.textContent = CSS; document.head.appendChild(st);
    }
    document.querySelectorAll('sub-widget').forEach(function (w) {
      if (w.handlePlanClick && w.allPlans) hook(w);
      else setTimeout(function () { hook(w); }, 50);
    });
  }
  if (window.customElements) customElements.whenDefined('sub-widget').then(function () { setTimeout(run, 0); });
})();

/* Mintier: product pages - keep the main price box in sync with the selected Recharge option.
   Subscription options show the plan total (price x quantity, e.g. 3 units for the 90-day supply)
   with the one-time total struck through; one-time restores the theme's own price markup. */
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1], product = null, lastSig = '';
  fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    .then(function (p) { product = p; tick(); }).catch(function () {});

  function money(cents, sample) {
    sample = (sample || '$0.00').trim();
    var mm = sample.match(/\d[\d.,\s]*\d|\d/);
    var comma = mm && /,\d{2}$/.test(mm[0]);
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    if (comma) v = v.replace(/\.(\d{2})$/, ',$1').replace(/,(?=\d{3})/g, '.');
    return mm ? sample.slice(0, mm.index) + v + sample.slice(mm.index + mm[0].length) : v;
  }
  function form() {
    var fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];
      if (f.querySelector('input[name="selling_plan"]') && f.querySelector('input[name="section-id"]') &&
          /__main$/.test(f.querySelector('input[name="section-id"]').value)) return f;
    }
    return null;
  }
  function val(f, n) { var e = f.querySelector('[name="' + n + '"]'); return e ? String(e.value || '') : ''; }
  function setText(root, sel, t) { root.querySelectorAll(sel).forEach(function (e) { e.textContent = t; }); }

  function tick() {
    if (!product) return;
    var f = form(); if (!f) return;
    var pb = document.getElementById('price-' + val(f, 'section-id')); if (!pb) return;
    var vid = val(f, 'id'), plan = val(f, 'selling_plan'), qty = parseInt(val(f, 'quantity'), 10) || 1;
    var fresh = !pb.querySelector('[data-mt-dyn]');
    var sig = vid + '|' + plan + '|' + qty;
    if (!fresh && sig === lastSig) return;
    if (fresh) { pb.__mtOrig = pb.innerHTML; }
    lastSig = sig;
    var v = null;
    for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === vid) v = product.variants[i];
    var alloc = null;
    if (v && plan) (v.selling_plan_allocations || []).forEach(function (a) { if (String(a.selling_plan_id) === plan) alloc = a; });
    pb.innerHTML = pb.__mtOrig;
    var pr = pb.querySelector('.price') || pb;
    pr.setAttribute('data-mt-dyn', sig);
    if (!alloc) return; /* one-time: theme markup as rendered */
    var sample = (pb.querySelector('.price-item--sale') || pb.querySelector('.price-item--regular') || {}).textContent;
    var total = alloc.price * qty;
    var compare = Math.max(alloc.compare_at_price || 0, v.price) * qty;
    var wasSale = pr.classList.contains('price--on-sale');
    setText(pb, '.price__regular .price-item--regular', money(total, sample));
    setText(pb, '.price-item--sale', money(total, sample));
    if (compare > total) {
      pr.classList.add('price--on-sale');
      var ps = pb.querySelector('.price__sale'); if (ps) ps.classList.add('visible');
      setText(pb, 's.price-item--regular', money(compare, sample));
      if (!wasSale) pb.querySelectorAll('.price__badge-sale').forEach(function (b) { b.style.display = 'none'; });
    } else {
      pr.classList.remove('price--on-sale');
    }
  }
  setInterval(tick, 250);
  document.addEventListener('change', function () { setTimeout(tick, 0); }, true);
})();
